import React from "react";

const AboutWorkSection = () => {
  return (
    <section className="section about-work-section">
      <div className="container">
        <div className="split-grid">
          <div
            className="section-image about-work-image"
            aria-label="Career team coordinating outreach and offers"
          ></div>
          <div>
            <p className="eyebrow">What We Do</p>
            <h2>A managed career engine from profile to offer.</h2>
            <p>
              We help candidates turn scattered effort into a coordinated
              job-search operating rhythm. The work spans positioning, outreach,
              application execution, interview readiness, and offer support.
            </p>
            <div className="check-grid">
              <span>Career Management</span>
              <span>Recruiter Outreach</span>
              <span>Resume &amp; Profile Optimization</span>
              <span>Offer &amp; Negotiation Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutWorkSection;
